import React from 'react';
import { useErrorsAndWarnings } from '../../hooks/ErrorsAndWarnings.js';
import { ActionsWidget } from '../do/ActionsWidget.js';
import { CurrentReadingPlan } from '../plans/read/CurrentReadingPlan.js';
import { PrayerSnapshot } from '../pray/PrayerSnapshot.js';
import { ShxHelpText } from '../common/ShxHelpText.js';
import { PageMainContainer, SHXRow } from '@soulhx/ui-common';
import { TutorialMessages } from './TutorialMessages.js';
import { AnnouncementSnapshot } from './comms-panel/announcement-snapshot/AnnouncementSnapshot.js';
import { ServerMessageSnapshot } from './comms-panel/server-message-snapshot/ServerMessagesSnapshot.js';

export const Home = () => {
  const { AlertUI, addErrorMessage } = useErrorsAndWarnings();

  return (
    <PageMainContainer>
      <AlertUI />

      <ShxHelpText pageName="home" textName="homeScreen" variant="success" />
      <ShxHelpText pageName="home" textName="welcomeMsg" firstLevel variant="warning" />

      <SHXRow className="gap-4 row-gap-5">
        <ServerMessageSnapshot />

        <TutorialMessages />

        <AnnouncementSnapshot />

        <ActionsWidget showTitle={true} showDetails={false} showLongNames={false} />

        <CurrentReadingPlan showTitle={true} />

        <PrayerSnapshot addErrorMessage={addErrorMessage} />
      </SHXRow>
    </PageMainContainer>
  );
};

export default Home;
